/**
 * 用于处理block的交互后加载
 */

import React from 'react';

const eventMap = {};

export function lazyBlockHoc(WrappedComponent) {
  return class extends React.Component<
    any,
    {
      shouldLoad: boolean;
    }
  > {
    state = {
      shouldLoad: false,
    };

    componentDidMount() {
      const { id } = this.props;
      if (!id) {
        throw new Error('every block should have id');
      }

      eventMap[id] = cb => {
        this.setState(
          {
            shouldLoad: true,
          },
          cb,
        );
      };
    }

    render() {
      const { shouldLoad } = this.state;

      if (!shouldLoad) return null;

      return <WrappedComponent {...this.props} />;
    }
  };
}

export function invoke(lazyBlockId: string, cb?) {
  const eventHandler = eventMap[lazyBlockId];

  if (eventHandler) {
    // LazyBlock的handler只会触发一次
    eventHandler(cb);
    eventMap[lazyBlockId] = null;
    return;
  } else if (eventHandler === undefined) {
    console.warn(`there is no lazy block registered that id is ${lazyBlockId}`);
  }

  cb();
}
